import React from 'react';
import { Box } from '@mui/material';

interface HighlightBoxProps {
  children: React.ReactNode;
  sx?: any;
}

const HighlightBox: React.FC<HighlightBoxProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        border: '1px solid var(--primary-blue)',
        borderRadius: '8px',
        padding: '20px',
        margin: '16px 0',
        borderLeft: '4px solid var(--primary-blue)',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default HighlightBox;

